import { createContext } from "react";
import type { TrackedNewObject } from "./trackCreatedObjects";

export const TrackedNewObjectsContext = createContext<
  TrackedNewObject[] | null
>(null);

export const TrackedNewObjectsProvider = ({
  value,
  children,
}: {
  value: TrackedNewObject[];
  children: React.ReactNode;
}) => (
  <TrackedNewObjectsContext.Provider value={value}>
    {children}
  </TrackedNewObjectsContext.Provider>
);
